import React from "react";
import Navbar from "./Navbar";
import Cookies from "../../../lib_react_frontend/utils/Cookies";

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export default (props) => (
  <header
    className="main-header"
    style={{
      alignSelf: "flex-end",
      backgroundImage: `url("${
        props.empresa.cod_empresa_usuario ? props.empresa.imagens.img_capa : ""
      }")`,
    }}
  >
    <a
      href={props.rota}
      className={"logo"}
      style={{ height: isMobile && "40px" }}
    >
      {/* O Logo pequeno: */}

      <span className="logo-mini">
        {props.empresa.cod_empresa_usuario ? (
          props.empresa.imagens.img_logo ? (
            <img
              style={{ height: "50px", width: "50px" }}
              src={props.empresa.imagens.img_logo}
              alt="Imagem Logo"
            />
          ) : (
            props.tituloPequeno
          )
        ) : (
          props.tituloPequeno
        )}
      </span>

      {/* O Logo grande com ícone: */}
      <span className="logo-lg">
        <span style={{ marginLeft: "5px" }} />
        {props.empresa.cod_empresa_usuario ? (
          props.empresa.imagens.img_logo ? (
            <img
              style={{ height: "40px", width: "120px" }}
              src={props.empresa.imagens.img_logo}
              alt="Imagem Logo"
            />
          ) : (
            props.tituloGrande
          )
        ) : (
          props.tituloGrande
        )}
      </span>
    </a>

    {/* A Barra: */}

    <div>
      {/* <nav className="navbar navbar-static-top"></nav> */}
      <nav
        className={
          isMobile ? "navbar-static-top-mobile" : "navbar navbar-static-top"
        }
        style={{
          position: "relative", // Adicione esta linha
          display: "flex",
          alignItems: "center",
          justifyContent: "center", // apenas centralize o span
          textAlign: "center",
        }}
      >
        {!isMobile && !props.escondeSidebar && (
          <a
            className="sidebar-toggle"
            data-toggle="offcanvas"
            style={{
              position: "absolute", // Adicione esta linha
              left: "10px", // Defina a posição do lado esquerdo conforme necessário
            }}
          />
        )}

        {props.dt_hr_ultima_sincronizacao && props.dt_hr_ultima_sincronizacao != "" && (
          <span
            style={{
              fontSize: "20px",
              color: "#fff",
            }}
          >
            Última Sincornização: {props.dt_hr_ultima_sincronizacao}
          </span>
        )}

        {!props.escondeUser && (
          <div
            style={{
              position: "absolute", // Adicione esta linha
              right: "-5px", // Defina a posição do lado direito conforme necessário
            }}
          >
            <Navbar
              options={props.options}
              onLogout={props.onLogout}
              onPreferencias={props.onPreferencias}
            />
          </div>
        )}
      </nav>
    </div>
  </header>
);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/template/header/Header.jsx